// WineClub.ph — Quick View Lazy Fetch Engine
(function () {
  const cache = {};
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${scrollY}px`;
  }

  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function showSpinner() {
    const container = document.getElementById('qv-modal-container');
    if (!container) return;
    container.innerHTML = `
      <div class="qv-modal" style="display:flex;" aria-hidden="false">
        <div class="qv-modal-overlay" onclick="closeQuickView()"></div>
        <div class="qv-modal-content">
          <button class="qv-close" onclick="closeQuickView()" aria-label="Close">&times;</button>
          <div class="qv-loading-spinner"></div>
        </div>
      </div>`;
    lockScroll();
  }

window.openQuickView = function (handle, productId) {
    showSpinner();

    if (cache[handle]) {
      const container = document.getElementById('qv-modal-container');
      container.style.opacity = '0';
      container.innerHTML = cache[handle];
      const modal = document.getElementById('QuickView-' + productId);
      if (modal) modal.style.display = 'flex';
      requestAnimationFrame(function() {
        container.style.transition = 'opacity 0.2s ease';
        container.style.opacity = '1';
      });
      return;
    }

    fetch('/products/' + handle + '?section_id=quick-view')
      .then(function (response) {
        if (!response.ok) throw new Error('Quick view fetch failed');
        return response.text();
      })
      .then(function (html) {
        cache[handle] = html;
        const container = document.getElementById('qv-modal-container');
        if (!container) return;
        container.style.opacity = '0';
        container.innerHTML = html;
        const modal = document.getElementById('QuickView-' + productId);
        if (modal) modal.style.display = 'flex';
        requestAnimationFrame(function() {
          container.style.transition = 'opacity 0.2s ease';
          container.style.opacity = '1';
        });
      })
      .catch(function () {
        window.location.href = '/products/' + handle;
      });
  };


  window.closeQuickView = function () {
    const container = document.getElementById('qv-modal-container');
    if (container) container.innerHTML = '';
    unlockScroll();
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeQuickView();
  });

  // Capture-phase listener — fires before Dawn's anchor pseudo-element
  document.addEventListener('click', function (e) {
    const pill = e.target.closest('.quick-view-hover-pill');
    if (!pill) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const handle = pill.dataset.productHandle;
    const id = pill.dataset.productId;
    if (handle && id) window.openQuickView(handle, id);
  }, true);

})();
